"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseController = void 0;
class BaseController {
    constructor(state, props, _setState) {
        this.state = state;
        this.props = props;
        this._setState = _setState;
        this.defaultState = undefined;
    }
    setState(state, callback) {
        if (this._setState) {
            this._setState((prevState) => (Object.assign(Object.assign({}, prevState), state)), callback);
        }
    }
    componentDidMount() { }
    componentWillUnMount() { }
}
exports.BaseController = BaseController;
//# sourceMappingURL=BaseController.js.map